// src/plugins/vuetify.js

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

// Get user-specific theme from localStorage
const userId = localStorage.getItem('userId') || 'default_user';
const themeKey = `${userId}_theme`;
const savedTheme = localStorage.getItem(themeKey) || 'light';

const vuetify = createVuetify({
  theme: {
    defaultTheme: savedTheme,
    themes: {
      light: {
        dark: false,
        colors: {
          // Primary Brand Colors
          primary: '#1F3C88',
          'primary-darken-1': '#2A4DBF',
          
          // Secondary/Accent
          secondary: '#1F3C88',
          accent: '#1F3C88',
          
          // Status Colors
          success: '#16A34A',
          warning: '#F59E0B',
          error: '#DC2626',
          info: '#2A4DBF',
          
          // UI Colors
          background: '#F9FAFB',
          surface: '#FFFFFF',
          sidebar: '#F4F6F8',
          
          // Text Colors
          'on-primary': '#FFFFFF',
          'on-secondary': '#FFFFFF',
          'on-background': '#1F2937',
          'on-surface': '#1F2937',
          
          // Additional colors
          'text-primary': '#1F2937',
          'text-secondary': '#6B7280',
          'border': '#E5E7EB',
        },
      },
      dark: {
        dark: true,
        colors: {
          // Primary Brand Colors (slightly adjusted for dark mode)
          primary: '#2A4DBF',
          'primary-darken-1': '#1F3C88',
          
          // Secondary/Accent
          secondary: '#2A4DBF',
          accent: '#2A4DBF',
          
          // Status Colors
          success: '#16A34A',
          warning: '#F59E0B',
          error: '#DC2626',
          info: '#2A4DBF',
          
          // UI Colors (dark mode)
          background: '#1F2937',
          surface: '#374151',
          sidebar: '#2D3748',
          
          // Text Colors
          'on-primary': '#FFFFFF',
          'on-secondary': '#FFFFFF',
          'on-background': '#F9FAFB',
          'on-surface': '#F9FAFB',
          
          // Additional colors
          'text-primary': '#F9FAFB',
          'text-secondary': '#D1D5DB',
          'border': '#4B5563',
        },
      },
    },
  },
  defaults: {
    // Global component defaults
    VBtn: {
      style: 'text-transform: none; letter-spacing: normal;',
      rounded: 'lg', // 10px radius
    },
    VCard: {
      rounded: 'xl', // 12px radius
      elevation: 0,
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VDataTable: {
      elevation: 0,
    },
    VList: {
      density: 'compact',
    },
  },
})

export default vuetify